import { Dossier } from '@sc/data-access-models';

export type AppointmentFilter =
  | 'NEW'
  | 'COMPLETED'
  | 'CANCELLED'
  | 'ABANDONED'
  | 'REQUESTED'
  | 'REQUESTED_AND_VALIDATED';

export type DossierState = 'COMPLETE' | 'SLOT_SUGGESTED' | 'DONE' | 'NO_SHOW';

export function getAppointmentApplicableFilter(
  dossier: Dossier
): AppointmentFilter {
  if (isDossierAppointmentNew(dossier)) {
    return 'NEW';
  } else if (isDossierAppointmentAbandoned(dossier)) {
    return 'ABANDONED';
  } else if (
    isDossierAppointmentCancelled(dossier) ||
    isDossierAppointmentNoShow(dossier)
  ) {
    return 'CANCELLED';
  } else if (isDossierAppointmentRequestedAndValidated(dossier)) {
    return 'REQUESTED_AND_VALIDATED';
  } else if (isDossierRequestAppointment(dossier)) {
    return 'REQUESTED';
  }
  return 'COMPLETED';
}

export function isDossierRequestAppointment(dossier: Dossier) {
  return !!dossier?.requestAppointment && !dossier?.appointment;
}

export function isDossierAppointmentNew(dossier: Dossier) {
  return (
    ['INIT', 'QUALIFIED', 'SLOT_SEARCH'].some(
      (state) => state === dossier.state
    ) &&
    (!dossier?.appointment?.id || !dossier?.appointment?.status) &&
    !isDossierRequestAppointment(dossier)
  );
}

export function isDossierAppointmentAbandoned(dossier: Dossier) {
  return dossier.state === 'ABANDONED';
}

export function isDossierAppointmentCancelled(dossier: Dossier) {
  return (
    dossier?.appointment?.status === 'CANCELLED' ||
    (!dossier?.appointment?.id &&
      dossier?.requestAppointment?.status === 'CANCELLED')
  );
}

export function isDossierAppointmentNoShow(dossier: Dossier) {
  return (
    dossier?.appointment?.status === 'NO_SHOW' || dossier?.state === 'NO_SHOW'
  );
}

export function isDossierAppointmentRequestedAndValidated(dossier: Dossier) {
  return (
    isDossierRequestAppointment(dossier) &&
    dossier?.requestAppointment?.isValidatedByFitter
  );
}

export function isDossierAppointmentComplete(dossier: Dossier) {
  return (
    !isDossierAppointmentNew(dossier) &&
    !isDossierAppointmentNoShow(dossier) &&
    !isDossierAppointmentCancelled(dossier) &&
    !isDossierAppointmentAbandoned(dossier) &&
    !isDossierRequestAppointment(dossier)
  );
}
